var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInMemory(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 40,
    viewBox: "0 0 97 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Property 1=Direct"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line",
    x1: 20.5,
    y1: 19.5,
    x2: 32.5,
    y2: 19.5,
    stroke: "#AED2FF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Src"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 12,
    width: 24,
    height: 16,
    rx: 2,
    fill: "#AED2FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fi-rr-rectangle-panoramic",
    clipPath: "url(#clip0_23673_349041)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M55.5 13.0006H41.5C40.1739 13.0006 38.9021 13.5274 37.9645 14.4651C37.0268 15.4028 36.5 16.6745 36.5 18.0006V22.0006C36.5 23.3267 37.0268 24.5985 37.9645 25.5361C38.9021 26.4738 40.1739 27.0006 41.5 27.0006H55.5C56.1566 27.0006 56.8068 26.8713 57.4134 26.62C58.02 26.3687 58.5712 26.0004 59.0355 25.5361C59.4998 25.0719 59.8681 24.5207 60.1194 23.914C60.3707 23.3074 60.5 22.6572 60.5 22.0006V18.0006C60.5 17.344 60.3707 16.6938 60.1194 16.0872C59.8681 15.4806 59.4998 14.9294 59.0355 14.4651C58.5712 14.0008 58.02 13.6325 57.4134 13.3812C56.8068 13.1299 56.1566 13.0006 55.5 13.0006V13.0006ZM58.5 22.0006C58.5 22.7963 58.1839 23.5593 57.6213 24.1219C57.0587 24.6845 56.2956 25.0006 55.5 25.0006H41.5C40.7044 25.0006 39.9413 24.6845 39.3787 24.1219C38.8161 23.5593 38.5 22.7963 38.5 22.0006V18.0006C38.5 17.205 38.8161 16.4419 39.3787 15.8793C39.9413 15.3167 40.7044 15.0006 41.5 15.0006H55.5C56.2956 15.0006 57.0587 15.3167 57.6213 15.8793C58.1839 16.4419 58.5 17.205 58.5 18.0006V22.0006Z",
    fill: "#265EDB"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Dest"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.5,
    y: 12,
    width: 24,
    height: 16,
    rx: 2,
    fill: "#AED2FF"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    x1: 64.5,
    y1: 19.5,
    x2: 76.5,
    y2: 19.5,
    stroke: "#AED2FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23673_349041"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(36.5 8)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInMemory);
export default __webpack_public_path__ + "static/media/in-memory.b1482481f122b9a434da056bcbf57c4c.svg";
export { ForwardRef as ReactComponent };